// 导入其他模块
import '@/styles/tailwind.scss';
import * as ReactDOM from 'react-dom/client';
import * as React from 'react';
import { enableMapSet } from 'immer';
import './utils/setVH';
import './utils/rem';
import BrowserPluginAlert from '@/component/browserPluginAlert';
import '@/utils/handleNetworkChange';
import { shouldWaitForElectronPreload } from '@/utils/environmentDetection';
import { SLS_CLIENT } from '@aliyun-sls/web-browser';
// Enable Immer MapSet plugin for Set support
import.meta.env.VITE_SLS_HOST &&
  SLS_CLIENT.init({
    host: import.meta.env.VITE_SLS_HOST,
    project: import.meta.env.VITE_SLS_PROJECT,
    logstore: import.meta.env.VITE_SLS_LOGSTORE,
    workspace: import.meta.env.VITE_SLS_WORKSPACE,
    env: import.meta.env.PROD ? 'prod' : 'dev',
    service: 'web',
    enableRuntimeError: true,
    enableResourcePerf: false,
    enableRequest: false,
    enablePerf: false,
    enableTrace: false,
  });
enableMapSet();

window.online = true;
// 初始化项结束
export const UseNoWechatBrowser = () => {
  const ua = navigator.userAgent.toLowerCase();
  const isWeChat = ua.includes('micromessenger');
  if (isWeChat) {
    location.href = '/openBrowser.html';
  }
};

const asyncImportChunkRender = async () => {
  // 优先加载关键模块
  const criticalModules = await Promise.all([
    import('./router').then((res) => res.UseDynamicRouting),
    import('react').then((res) => res.useMemo),
    import('react-router').then((res) => res.RouterProvider),
    import('./app').then((res) => res.App),
  ]);

  const [UseDynamicRouting, useMemo, RouterProvider, App] = criticalModules;

  const root = ReactDOM.createRoot(document.getElementById('app')!);

  // 创建懒加载组件
  const LazyVersionUpdate = React.lazy(
    () => import('@/component/versionUpdate'),
  );
  const LazyConfettiRender = React.lazy(
    () => import('@/component/ConfettiRender'),
  );
  const LazyFireUpdateRenderer = React.lazy(
    () => import('@/component/fireUpdateRenderer'),
  );
  const Root = () => {
    const router = UseDynamicRouting();
    UseNoWechatBrowser();

    return useMemo(() => {
      return (
        <App>
          <BrowserPluginAlert />
          <React.Suspense fallback={null}>
            <LazyVersionUpdate />
            <LazyConfettiRender />
            <LazyFireUpdateRenderer />
          </React.Suspense>
          <RouterProvider router={router} />
        </App>
      );
    }, [router]);
  };
  // 等待 Electron preload 初始化，设置超时保护
  if (shouldWaitForElectronPreload()) {
    try {
      await window.waitForElectron();
      console.log('[Electron] Preload initialized successfully');
    } catch (error) {
      console.error('[Electron] Failed to initialize preload:', error);
      // 即使 preload 初始化失败，也继续渲染应用
      // 这样可以避免应用完全无法启动
    }
  }
  root.render(<Root />);

  // 渲染完成后，隐藏 JIT loading 动画（如果存在）
  if (typeof window.hideJitLoading === 'function') {
    window.hideJitLoading();
  }
};
document.addEventListener(
  'DOMContentLoaded',
  () => void asyncImportChunkRender(),
);
